import React, {useEffect, useRef, useState} from 'react';
import InputMUISearch from '../../../shared/InputMUISearch';
import IconButtonMUI from '../../../shared/IconButtonMUI';
import Filter from '../../Components/Filter/Filter';
import {ReactComponent as FilterIcon} from '../../../assets/icons/filter.svg';
import {ReactComponent as DeleteIcon} from '../../../assets/icons/delete-item.svg';
import {ReactComponent as NotificationIcon} from '../../../assets/icons/notification.svg';
import {ReactComponent as LocationIcon} from '../../../assets/icons/location.svg';
import {ReactComponent as CalendarIcon} from '../../../assets/icons/cal.svg';
import {ReactComponent as ProgressIcon} from '../../../assets/icons/progress-status.svg';
import {ReactComponent as SuspendedIcon} from '../../../assets/icons/planned-status.svg';
import {ReactComponent as CompletedIcon} from '../../../assets/icons/completed-status.svg';
import {ReactComponent as ProjectIcon} from '../../../assets/icons/project-btn.svg';
import {ReactComponent as TimeIcon} from '../../../assets/icons/time-new-svgrepo-com.svg';
import avatarIcon from '../../../assets/images/project/avatar.png';
import './YourProjects.scss';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../Components/LoadPanel';
import NoItems from '../../Components/NoItems';
import {setModal} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import {dateFormat, PERMISSIONS} from '../../../helpers/constants';
import {hasPermission} from '../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import Count from '../../Components/Count';
import {getCities} from "../../../redux/actions/countries/countriesActions";
import {notifyError} from "../../../helpers/notifySnack";
import dayjs from "dayjs";
import {SelectComponent} from "../../../shared";
import {setFilterStatusProject} from "../../../redux/actions/projects/projectsActions";

const YourProjects = ({handleProjectSelect}) => {
    const dispatch = useDispatch();
    const projectList = useSelector(({projects}) => projects.projects);
    const projectStatus = useSelector(({projects}) => projects.projectStatus);
    const projectLoading = useSelector(({projects}) => projects.projectsLoading);
    const {t} = useTranslation();
    const history = useHistory();
    const [searchProjects, setSearchProjects] = useState('');
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const {cities, citiesLoading} = useSelector(({countries}) => countries);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const {profileMe} = useSelector((state) => state.profile);
    const isFinancier = profileMe.role === 'financier';

    const projectStatuses = [
        {name: t('ProjectsCheckboxPanel.all'), id: 'all'},
        {name: t('CompaniesHome.active'), id: 'active'},
        {name: t('CompaniesHome.paused'), id: 'pause'},
        {name: t('CompaniesHome.done'), id: 'done'}
    ];

    const location = useLocation();

    const handleClear = () => {
        setSearchProjects('');
    };

    const getCityById = (id) => {
        return cities?.find(elem => elem?.id === id);
    }

    const handleChange = (event) => {
        setSearchProjects(event.target.value);
    };

    const initialFilters = [];

    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        const fetchFunc = async () => {
            try {
                if (citiesLoading) {
                    await dispatch(getCities());
                }
            } catch (error) {
                notifyError(error.message || 'error');
            }
        };

        fetchFunc();
    }, []);

    useEffect(() => {
        if (projectList.length) {
            const params = new URLSearchParams(location.search);
            const newFilters = [];

            params.forEach((value, key) => {
                if (value === 'all') {
                    return false
                } else if (key === 'pT') {
                    newFilters.push({id: key, name: value, value: value});
                } else if (key === 'pS') {
                    dispatch(setFilterStatusProject(value))
                } else if (key === 'cId') {
                    const companyItem = projectList.find((item) => item.companyId === value);
                    if (companyItem) {
                        newFilters.push({id: key, name: companyItem?.companyName, value: value});
                    } else {
                        newFilters.push({id: key, name: t('all.filterCompany'), value: value});

                    }
                } else if (key === 'city') {
                    const city = getCityById(value)
                    if (city) {
                        newFilters.push({id: key, name: city?.name, value: value});
                    } else {
                        removeFilter(name, key, value);
                    }
                } else {
                    removeFilter(name, key, value);
                }
            });

            setFilters(newFilters);
        }
    }, [location.search, projectList]);

    const removeFilter = (name, id, value) => {
        setFilters((prevFilters) => prevFilters.filter(filter => filter.name !== name));

        const params = new URLSearchParams(location.search);

        const allValues = params.getAll(id);

        let deleted = false;
        allValues.forEach((paramValue, index) => {
            if (paramValue === value && !deleted) {
                params.delete(id, paramValue);
                deleted = true;
            }
        });

        history.replace({
            pathname: location.pathname,
            search: params.toString() ? `?${params.toString()}` : '',
        });
    };
    const toggleFilterVisibility = () => {
        setIsFilterVisible(!isFilterVisible);
    };

    const closeFilter = () => {
        setIsFilterVisible(false);
    };

    const handleNavigate = () => {
        dispatch(setModal(POPUPS.PROJECT_POPUP));
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const cityQuery = queryParams.get('city') || '';
        const pTQuery = queryParams.getAll('pT') || '';
        const cIdQuery = queryParams.get('cId') || '';

        const filterProjects = () => {
            return projectList.filter((project) => {
                const matchesSearch = project.address.toLowerCase().includes(searchProjects.toLowerCase());
                if (filters.length || projectStatus) {
                    const matchesCity = cityQuery ? project?.city?.id === cityQuery : true;
                    const matchesCompany = cIdQuery ? project?.companyId === cIdQuery : true;

                    const matchesStatus = projectStatus !== 'all' ? project?.status?.toLowerCase() === projectStatus : true;
                    const matchesPType = pTQuery?.length
                        ? project?.types?.some(type => pTQuery.some(pt => pt?.toLowerCase() === type?.name?.trim()?.toLowerCase()))
                        : true;
                    return matchesSearch && matchesCity && matchesCompany && matchesPType && matchesStatus;
                }
                return matchesSearch
            });
        };


        setFilteredProjects(filterProjects());
    }, [projectList, searchProjects, filters,projectStatus]);

    const projectRefs = useRef({});

    const setProjectRef = (id, element) => {
        if (element) {
            projectRefs.current[id] = element;
        }
    };
    useEffect(() => {
        if (filteredProjects.length) {
            const path = window.location.pathname;
            const match = path.match(/projects\/([^/]+)/);
            const urlProjectId = match ? match[1] : null;
            const projectElement = projectRefs.current[urlProjectId];

            if (projectElement) {
                projectElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }
    }, [location.pathname, filteredProjects]);

    function getDaysWord(days) {
        const lastDigit = days % 10;
        const lastTwoDigits = days % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return t('day.many');
        } else if (lastDigit === 1) {
            return t('day.single');
        } else if (lastDigit >= 2 && lastDigit <= 4) {
            return t('day.few');
        } else {
            return t('day.many');
        }
    }

    const isSpectatorOrClient = profileMe?.role === 'user' || profileMe?.role === 'spectator';

    const handleNavigateCompany = () => {
        history.push(mainPath.companies);
    };

    const handleFilterStatuses = (e) => {
        const newStatus = e.target.value;

        const searchParams = new URLSearchParams(window.location.search);

        dispatch(setFilterStatusProject(newStatus))

        history.push(`?${searchParams.toString()}`);
    };


    return (
        <div className='your-projects'>
            {projectLoading ? (
                <LoadPanel/>
            ) : (
                <>
                    {projectList.length > 0 ? (
                        <>
                            <div className='your-projects__head'>
                                <div className='your-projects__head-title'>{t('YourProjects.your_projects')}</div>
                                <div className='your-projects__head-btn'>
                                    {!isSpectatorOrClient ? (
                                        <IconButtonMUI onClick={handleNavigateCompany} color='primary'
                                                       className='project'>
                                            <ProjectIcon/>
                                        </IconButtonMUI>
                                    ) : null}
                                    {profileMe?.role === 'user' || profileMe?.role === 'spectator' ? null :
                                        <IconButtonMUI color='primary' onClick={toggleFilterVisibility}>
                                            <FilterIcon/>
                                        </IconButtonMUI>}

                                </div>
                            </div>

                            <div className="your-projects__select">
                                <SelectComponent
                                    onChange={handleFilterStatuses}
                                    value={projectStatus}
                                    options={projectStatuses}
                                    allowClear={false}
                                    fullWidth={true}
                                    label={t('all.filter')}
                                />
                            </div>
                            <div className='your-projects__search'>
                                <InputMUISearch
                                    className='search-box__input'
                                    fullWidth
                                    value={searchProjects}
                                    onClear={handleClear}
                                    onChange={handleChange}
                                    placeholder={t('YourProjects.search_placeholder')}
                                />
                            </div>

                            <div className='your-projects__active-filters'>
                                {filters.map(({id, name, value}) => {
                                    if(id === 'pS') return null
                                    if (name) {
                                            return (
                                                <div key={value} className='filter-item'>
                                                    <div className='filter-item__title'>{name}</div>
                                                    <IconButtonMUI size='small'
                                                                   onClick={() => removeFilter(name, id, value)}>
                                                        <DeleteIcon/>
                                                    </IconButtonMUI>
                                                </div>
                                            )
                                        }
                                    }
                                )}
                            </div>

                            <div className='your-projects__list'>
                                {filteredProjects.map((project) => {
                                    const rating = project?.rate || 0;
                                    const fillPercentage = (rating / 5) * 100;

                                    return (
                                        <NavLink
                                            to={mainPath.project.replace(':id', project.id)}
                                            className={`projects-item`}
                                            key={project.id}
                                            onClick={handleProjectSelect}
                                            ref={(el) => setProjectRef(project.id, el)}
                                        >
                                            <div className='projects-item__image'>
                                                {project.logo ? <img src={project.logo} alt=''/> :
                                                    <img src={avatarIcon} alt={'avatar'}/>}
                                                {!isFinancier && project.hasNotification && (
                                                    <div className='projects-item__notification'>
                                                        <NotificationIcon/>
                                                    </div>
                                                )}
                                                {!isFinancier && project?.messageCount > 0 && (
                                                    <div className={'projects-item__chats'}>
                                                        <Count count={project.messageCount} color={'blue'}
                                                               size={'xxs'}/>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='projects-item__info'>
                                                <div className='projects-item__address'>{project.address}</div>
                                                <div className='projects-item__place'>
                                                    <LocationIcon/>
                                                    {project.city?.name}
                                                    {project.created_at ? <div className={'projects-item__time'}>
                                                        <TimeIcon/>
                                                        {dayjs(project.created_at).format(dateFormat)}
                                                    </div> : ''}
                                                </div>
                                                <div className='projects-item__details'>
                                                    <div className='projects-item__rating'>
                                                        <svg
                                                            width='16'
                                                            height='16'
                                                            viewBox='0 0 16 16'
                                                            fill='none'
                                                            xmlns='http://www.w3.org/2000/svg'
                                                        >
                                                            <defs>
                                                                <linearGradient id={`starGradient-${project.id}`}
                                                                                x1='0%' y1='0%' x2='100%' y2='0%'>
                                                                    <stop offset={`${fillPercentage}%`}
                                                                          stopColor='#FFB508'/>
                                                                    <stop offset={`${fillPercentage}%`}
                                                                          stopColor='transparent'/>
                                                                </linearGradient>
                                                            </defs>
                                                            <path
                                                                d='M8.51782 1.65535L10.1524 4.95543C10.1896 5.03919 10.2481 5.11175 10.3221 5.16586C10.396 5.21998 10.4829 5.25376 10.5739 5.26385L14.1824 5.79844C14.2869 5.81187 14.3854 5.85475 14.4665 5.92207C14.5475 5.9894 14.6077 6.07838 14.64 6.17863C14.6724 6.27889 14.6755 6.38628 14.6491 6.48825C14.6227 6.59023 14.5678 6.68259 14.4909 6.75454L11.8899 9.33498C11.8235 9.397 11.7737 9.47464 11.7449 9.56082C11.7162 9.64701 11.7095 9.73901 11.7254 9.82845L12.3525 13.4575C12.3707 13.5618 12.3592 13.6691 12.3194 13.7672C12.2796 13.8652 12.213 13.9502 12.1273 14.0123C12.0416 14.0744 11.9402 14.1113 11.8346 14.1186C11.729 14.1259 11.6235 14.1035 11.53 14.0538L8.28136 12.3369C8.19817 12.2961 8.10673 12.2749 8.01406 12.2749C7.92139 12.2749 7.82995 12.2961 7.74677 12.3369L4.49808 14.0538C4.40462 14.1035 4.29909 14.1259 4.1935 14.1186C4.0879 14.1113 3.98649 14.0744 3.90079 14.0123C3.8151 13.9502 3.74856 13.8652 3.70876 13.7672C3.66895 13.6691 3.65748 13.5618 3.67563 13.4575L4.30275 9.78733C4.31865 9.69789 4.31192 9.60589 4.2832 9.5197C4.25447 9.43352 4.20465 9.35588 4.13826 9.29386L1.50642 6.75454C1.42856 6.68062 1.3738 6.58571 1.34878 6.4813C1.32376 6.37689 1.32955 6.26747 1.36546 6.16628C1.40136 6.0651 1.46583 5.9765 1.55107 5.91121C1.6363 5.84593 1.73864 5.80675 1.84568 5.79844L5.45418 5.26385C5.54527 5.25376 5.63212 5.21998 5.70607 5.16586C5.78003 5.11175 5.83851 5.03919 5.87569 4.95543L7.51031 1.65535C7.55483 1.55923 7.62591 1.47786 7.71517 1.42083C7.80443 1.3638 7.90814 1.3335 8.01406 1.3335C8.11999 1.3335 8.2237 1.3638 8.31296 1.42083C8.40222 1.47786 8.4733 1.55923 8.51782 1.65535V1.65535Z'
                                                                stroke={fillPercentage > 0 ? '#FFB508' : '#736A85'}
                                                                strokeWidth='1.5'
                                                                strokeLinecap='round'
                                                                strokeLinejoin='round'
                                                                fill={`url(#starGradient-${project.id})`}
                                                            />
                                                        </svg>
                                                        {project.rate}
                                                    </div>

                                                    {project.status === 'active' && (
                                                        <div className='projects-item__status progress'>
                                                            <ProgressIcon/>
                                                            {t('YourProjects.status_in_progress')}
                                                        </div>
                                                    )}
                                                    {project.status === 'done' && (
                                                        <div className='projects-item__status completed'>
                                                            <CompletedIcon/>
                                                            {t('YourProjects.status_completed')}
                                                        </div>
                                                    )}

                                                    {project.types && project.types?.length
                                                        ? project.types.map((el, idx) => {
                                                            return (
                                                                <div key={idx}
                                                                     className={`projects-item__type projects-item__type--${idx}`}>
                                                                    {el.name}
                                                                </div>
                                                            );
                                                        })
                                                        : null}

                                                    {project.status === 'pause' && (
                                                        <>
                                                            <div className='projects-item__status suspended'>
                                                                <SuspendedIcon/>
                                                                {t('YourProjects.status_suspended')}
                                                            </div>
                                                        </>
                                                    )}
                                                    {project.paused > 0 ? (
                                                        <div className='projects-item__cal'>
                                                            <CalendarIcon/>
                                                            {project.paused + ' ' + getDaysWord(project.paused)}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </NavLink>
                                    );
                                })}
                            </div>

                            {isFilterVisible &&
                                <Filter filters={filters} setFilters={setFilters} onClose={closeFilter}/>}
                        </>
                    ) : (
                        <NoItems
                            description={t('YourProjects.no_items_description')}
                            buttonText={t('YourProjects.no_items_button_text')}
                            title={t('YourProjects.no_items_title')}
                            handleNavigate={handleNavigate}
                            disabled={!hasPermission(PERMISSIONS.PROJECT_CREATE, profileMe?.permissions ?? [])}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default YourProjects;
